// N-15b: 通知先の LINE 宛先ピッカー用の候補検索（pure / client-side）。
//
// tenant-reservation の `customerSearch.ts`（M-121）と同じ「全件をクライアントで絞る」方針。
// こちらは **通知が届く人**を選ぶので、`lineUserId` が無い顧客と `lineBlocked` の顧客は
// 母集団から外す（選べても届かないため）。

import type { AppUser } from '@kawai/shared';

/** 候補として出す最大件数。 */
export const RECIPIENT_CUSTOMER_SEARCH_LIMIT = 20;

/** LINE 宛先に選べる顧客か（`lineUserId` あり & 未ブロック）。 */
export function isSelectableLineCustomer(user: AppUser): boolean {
  return typeof user.lineUserId === 'string' && user.lineUserId.length > 0 && !user.lineBlocked;
}

/**
 * 名前（LINE 表示名 / 予約氏名 / カナ）の部分一致で候補を返す。空クエリは空配列。
 */
export function searchRecipientCustomers(
  users: ReadonlyArray<AppUser>,
  query: string,
  limit: number = RECIPIENT_CUSTOMER_SEARCH_LIMIT,
): AppUser[] {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  const out: AppUser[] = [];
  for (const user of users) {
    if (!isSelectableLineCustomer(user)) continue;
    const names = [user.displayName, user.bookingName, user.bookingKana];
    if (names.some((n) => typeof n === 'string' && n.toLowerCase().includes(q))) {
      out.push(user);
      if (out.length >= limit) break;
    }
  }
  return out;
}

/** 候補表示用ラベル: LINE 表示名 + 予約氏名（あれば）。 */
export function recipientCustomerLabel(user: Pick<AppUser, 'displayName' | 'bookingName'>): string {
  if (user.bookingName && user.bookingName !== user.displayName) {
    return `${user.displayName}（予約名: ${user.bookingName}）`;
  }
  return user.displayName;
}
